import React, { useImperativeHandle, useState } from 'react';
import { connect } from 'react-redux';
import { useI18n } from '../../../../../i18n';
import { cx } from '../../../../api';
import Form from '../../../general/form/Form';
import { actions } from '../../../../redux/api/reports';
import ObjectDeviceManager from '../../../share/devices/ObjectDeviceManager';
import EventTypePicker from 'core/react/share/events/EventTypePicker';
import { localStorage as storage } from 'core/app/storage';
import DummyControl from 'core/react/general/form/DummyControl';
import GroupingPicker from 'core/react/share/categories/GroupingPicker';

import './deviceStuations.scss';

const BATCH_SIZE = 70;

/**
 * @param {Object} props
 * @param {React.RefObject} props.customRef
 * @param {Object} props.timeRange
 * @param {boolean} [props.disabled]
 */

function DeviceSituations(props) {
	const { fc, f } = useI18n();

	const [isAssetTypes, setIsAssetTypes] = useState(false);
	const [isGrouping, setGrouping] = useState(false);
	const [groupingId, setGroupingId] = useState(storage.get('groupingId'));

	useImperativeHandle(props.customRef, () => ({
		submit: (values) => {
			const parameters = new cx.ods.reports.DeviceSituationReportParameters();

			if (values.uris?.length > 0) {
				parameters.uris = values.uris
			}

			parameters.eventTypes = values.eventTypes?.length ? values.eventTypes : null;
			parameters.timeRange = props.timeRange;
			parameters.timeRange.window = new cx.ods.TimeWindow(BATCH_SIZE);
			parameters.markers = values.markers;
			parameters.groupingId = isGrouping ? groupingId : null;
			parameters.isAssetTypes = isAssetTypes;
			props.dispatch(actions.deviceSituations.request({ parameters, clear: true }));
		},
		clear: () => {
			props.dispatch(actions.deviceSituations.exportClear());
		}
	}));

	return (
		<div className="device-situations-parameters" >
			<Form.ControlGroup key={50} disabled={props.disabled}>
				<Form.Control
					controlName="markers"
					controlType={Form.Control.Type.Checkbox}
					label={f('locate pre-start markers')}
					initialValue={props.state.parameters ? props.state.parameters.markers : false}
				/>
			</Form.ControlGroup>
			<ObjectDeviceManager
				controlName="uris"
				title={fc('devices restriction')}
				disabled={props.disabled}
				emptyMessage={f('all devices')}
				editMode
				uris={props.state.parameters?.uris}
			/>
			<Form.Control
				controlType={EventTypePicker}
				controlName="eventTypes"
				label={f('event types')}
				placeholder={f('default event type')}
				initialValue={props.state?.parameters?.eventTypes || null}
			/>
			<Form.Control
				controlType={Form.Control.Type.Checkbox}
				controlName="isGrouping"
				value={isGrouping}
				onChange={setGrouping}
				label={f('include device grouping')}
				disabled={props.disabled}
			/>
			<Form.Control controlType={DummyControl} controlName="grouping" value={groupingId} onChange={() => {}} hidden />
			<GroupingPicker
				disabled={props.disabled || !isGrouping}
				categoryId={groupingId}
				onChange={setGroupingId}
				cleanable={false}
			/>
			<Form.Control
				controlType={Form.Control.Type.Checkbox}
				controlName="isAssetTypes"
				value={isAssetTypes}
				onChange={setIsAssetTypes}
				label={f('include asset types')}
				disabled={props.disabled}
			/>
		</div>
	)
}

export default connect(state => {
	return {
		state: state.reports.deviceSituations
	}
})(DeviceSituations);
